import axios from '../axios'
import qs from 'qs';

/* 
 * 设备管理模块
 */

// 创建
export const add = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/equipment/add',
        method: 'post',
        data
    })
}
// 查询
export const list = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/equipment/list',
        method: 'post',
        data
    })
}
// 修改
export const update = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/equipment/update',
        method: 'post',
        data
    })
}
// 删除
export const del = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/equipment/delete',
        method: 'post',
        data
    })
}
// 绑定设备到用户（ids绑定单用户）
export const bind = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/equipment/bind',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/device.js